
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.875 1.028a3 3 0 00-3 3v9a3 3 0 003 3h2.25v1.44c0 1.268 1.475 1.965 2.454 1.159l3.155-2.599h4.141a3 3 0 003-3v-9a3 3 0 00-3-3h-12zm9.822 9.04c.285-.459.01-1.026-.5-1.205-.51-.18-1.058.108-1.415.513a2.547 2.547 0 01-3.341.417 2.543 2.543 0 01-.434-.374c-.367-.397-.921-.672-1.426-.481-.506.19-.769.764-.473 1.216a4.5 4.5 0 007.589-.086zM9.875 6.692a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z","fill":"#191F2D"}})])
          )
        }
      }
    